import React from 'react';
import CarousalContainer from './components/CarousalContainer';
import './Home.css';
// import {
// 	Card, CardImg, CardText, CardBody,
// 	CardTitle, CardSubtitle, Button
//   } from 'reactstrap';

const Home =() => {
  return (
  <>
 <div className="container5">
 <CarousalContainer/>

 <div className="box-container wpb_row vc_row-fluid vc_custom_1411368076285" 
style={{color: "rgb(255, 255, 255)"}}>
<div className="container dt-container">
<div className="row">
	<div className="vc_col-sm-3 wpb_column column_container">
		<div className="wpb_wrapper">
			
		</div> 
	</div> 

	<div className="vc_col-sm-6 wpb_column column_container">
		<div className="wpb_wrapper">
			<div id="section-1-1619683825" className=" dt-section-head center size-default hide-overflow">
            <div className="dt-section-container">
            <h2 className="section-main-title section-heading-polkadot-left-right " style={{color:"black",fontSize:"xx-large",fontWeight:"500",paddingBottom:"10px"}}>
                Our Mission
            </h2>
            </div>
      </div>
	<div className="wpb_text_column wpb_content_element  wpb_animate_when_almost_visible wpb_left-to-right left-to-right wpb_start_animation animated">
		<div className="wpb_wrapper">
			<p style={{textAlign: "center",fontStyle:"italic",color:"black"}}><em>“To be the most preferred LSP by continuously adapting to the ever growing business environment through ethical business practices and strict adherence towards the effective QMS.”</em></p>

		</div> 
	</div> 
		</div> 
	</div> 

	<div className="vc_col-sm-3 wpb_column column_container">
		<div className="wpb_wrapper">
			
		</div> 
	</div> 
</div></div></div>

<div className="container1">
  <img src="indiantruck.jpg" alt="Nature" style={{width:"100%",height:"600px"}}/>
  <div className="text-block">
    <h4 style={{color:"white",fontSize:"40px",borderColor:"black"}}>
OUR STRENGTHS</h4>
    <p>3 Decades of Experience in handling ODC and Heavy Equipment Transport</p>
  </div>
</div>





<div className="cards">
  <div className="card">
    <img className="card__image" src="milk.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title" style={{fontSize:"30px"}}>Milk Run</h3>
      <p>
      Milk Run services applied where the load is scattered in many different places and in smaller units. In such a case carrying from each centre individually would be very expensive, hence a scheme is designed as per the requirements and accordingly all different units .

      </p>
    </div>
    
  </div>
  <div className="card">
    <img className="card__image" src="taurus-21ton.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title"style={{fontSize:"30px"}}>Long Haul</h3>
      <p>
      Long Haul is the movement of cargo between two major cities. Star Roadline has the experience and the knowledge to help you with your long haul transportation needs.
      </p>
    </div>
    
  </div>
  <div className="card">
    <img className="card__image" src="eicher-19feet.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title"style={{fontSize:"30px"}}>Local Distrubution</h3>
      <p>
      Our local freight distribution system enables us to exactly match your local transportation and logistic needs, vehicles in various types engaged dedicatedly to serve our customers locally.
      </p>
    </div>
    
  </div>
  <div className="card">
    <img className="card__image" src="load.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title"style={{fontSize:"30px"}}>Part Load</h3>
      <p>
      Part load transport service in India, we capture every transportation route and meet your requirements. We provide full & part load transportation Services with varied type of trucks.
      </p>
    </div>
   
  </div>



  <div className="card">
    <img className="card__image" src="jit.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title"style={{fontSize:"30px"}}>JIT Supplies</h3>
      <p>
      The just-in-time supply system is a management strategy that aligns raw-material orders from suppliers directly with production schedules. Companies use this strategy to increase efficiency with low inventory levels.
      </p>
    </div>
    
  </div>

  <div className="card">
    <img className="card__image" src="gps.jpg" alt=""/>
    <div className="card__content">
	<h3 className="elementor-image-box-title"style={{fontSize:"30px"}}>Local Distrubution</h3>
      <p>
      All our vehicles are GPS enabled for easy tracking. Our customer can track and trace the vehicles from their end as we share the access of our vehicle tracking system to them.
      </p>
    </div>
    
  </div>
</div>
</div>
</>
);
}; 
export default Home;